export default `
<feed-item pinnable="isLoggedInUser" show-pin store="statusStore" item="status" ng-repeat="status in statusStore.feedItems" ></feed-item>
<ut-load-more (load-more)="statusStore.loadMore()" [is-loading]="statusStore.isLoading" [is-last-page]="statusStore.isLastPage"></ut-load-more>
`;
